import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { useNavigate } from "react-router-dom";

const useProDashboard = () => {
    //const [proDashboard, setProDashboard] = useLocalStorage("proDashboard", false);
    const [proDashboard, setProDashboard] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        //const savedProDashboard = localStorage.getItem("proDashboard");
        //if (savedProDashboard !== null) {
        //    setProDashboard(JSON.parse(savedProDashboard));
        //} else {
        //    setProDashboard(false);
        //}
        if (window.location.href.includes("/pro/")) {
            setProDashboard(true);
        } else {
            setProDashboard(false);
        }
    }, []);

    // Toggle tra dashboard normale e dashboard pro
    const toggleProDashboard = () => {
        const newProDashboard = !proDashboard;
        setProDashboard(newProDashboard);
        localStorage.setItem("proDashboard", JSON.stringify(newProDashboard));

        newProDashboard ? navigate("/pro/home") : navigate("/home");
    };

    return [proDashboard, toggleProDashboard];
};

export default useProDashboard;
